import React, { useState, forwardRef, useImperativeHandle } from 'react';

import { Box } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import Slide from '@material-ui/core/Slide';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import { useSnackbar } from 'notistack';

import { api } from '../../../services';
import { formatDateDDMMYYYYHHmm, SECONDARY_COLOR } from '../../../utils';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    // color: theme.palette.grey[500],
    color: 'white',
  },
});

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: SECONDARY_COLOR,
    color: theme.palette.common.white,
    padding: 3,
  },
  body: {
    fontSize: 14,
    padding: 3,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, textAlign = 'left', ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h5" style={{ fontWeight: 'bold', textAlign }}>
        {children}
      </Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon style={{ color: 'white' }} />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogoCategoriaTransacao = forwardRef((props, ref) => {
  const [open, setOpen] = useState(false);
  const [id, setId] = useState(0);
  const [itens, setItens] = useState([]);
  const [nota, setNota] = useState(null);
  const { enqueueSnackbar } = useSnackbar();

  const handleCloseDialog = () => {
    setOpen(false);
  };

  async function getDataResource(id) {
    try {
      const response = await api.get(`/notas-fiscais-testes-detalhes/${id}`);
      const data = response.data;

      const { nota, produtos } = data;

      setNota(nota);
      setItens(produtos);
    } catch (erros) {
      enqueueSnackbar(`${erros}`, {
        variant: 'error',
      });
      handleCloseDialog();
    }
  }

  useImperativeHandle(ref, () => ({
    handleOpen(id) {
      setId(id);
      setOpen(true);
      getDataResource(id);
    },
  }));

  return (
    <div>
      <Dialog
        open={open}
        aria-labelledby="form-dialog-title"
        fullWidth
        maxWidth="sm"
        TransitionComponent={Transition}
        keepMounted
      >
        <DialogTitle
          id="form-dialog-title"
          onClose={handleCloseDialog}
          style={{
            backgroundColor: SECONDARY_COLOR,
            color: 'white',
          }}
        >
          {`Detalhes Nota Fiscal de Teste ${id}`}
        </DialogTitle>
        <DialogContent
          style={{
            margin: '0',
          }}
        >
          <Typography
            variant="h5"
            gutterBottom
            style={{
              fontWeight: 'bold',
              textAlign: 'center',
            }}
          >
            Geral
          </Typography>
          {nota ? (
            <>
              <Box display="flex" alignItems="center" mt="20px" fontSize={20}>
                <Box flex={1}>
                  <span
                    style={{
                      marginRight: '10px',
                      fontWeight: 'bold',
                    }}
                  >
                    ID:
                  </span>
                  {nota.id}
                </Box>
                <Box flex={1}>
                  <span
                    style={{
                      marginRight: '10px',
                      fontWeight: 'bold',
                    }}
                  >
                    Status:
                  </span>
                  {nota.status ? 'Verificado' : 'Não Verificado'}
                </Box>
              </Box>
              <Box display="flex" alignItems="center" mt="20px" fontSize={20}>
                <Box flex={1}>
                  <span
                    style={{
                      marginRight: '10px',
                      fontWeight: 'bold',
                    }}
                  >
                    Data:
                  </span>
                  {formatDateDDMMYYYYHHmm(nota.data)}
                </Box>
                <Box flex={1} />
              </Box>
            </>
          ) : null}
          <Typography
            variant="h5"
            gutterBottom
            style={{
              fontWeight: 'bold',
              textAlign: 'center',
              marginTop: '20px',
            }}
          >
            Produtos
          </Typography>
          <TableContainer component={Paper}>
            <Table aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell>ID</StyledTableCell>
                  <StyledTableCell>Descrição</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {itens.map((row, ind) => (
                  <StyledTableRow key={`${ind}-row`}>
                    <StyledTableCell>{row.id}</StyledTableCell>
                    <StyledTableCell>{row.nome}</StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
      </Dialog>
    </div>
  );
});

export default DialogoCategoriaTransacao;
